import { TExperiment } from '@printdeal/feature-management/react';
import { PriceAttribute, SelectorContent } from '@printdeal/product-selector';
import { ValidationAttribute } from '../../../../types/selector/Selector';
import { ExperimentationContainer } from '../../../../types/product/productDetailPage';

export function getAttribute(options: ValidationAttribute[], key: string) {
  return options?.find((attribute) => attribute.attributeKey === key);
}

export const determineSelector = (
  isInitialized: boolean,
  experiment: TExperiment<{}> | null,
  resolvedSelectors?: SelectorContent,
  selectorExperiment?: ExperimentationContainer,
): SelectorContent | undefined => {
  if (selectorExperiment || resolvedSelectors) {
    if (isInitialized) {
      // If we have an experiment, we will use the variation from the experiment
      if (selectorExperiment && experiment?.variation) {
        return selectorExperiment[experiment.variation];
      }

      // If we don't have an experiment, we will use the resolved selectors
      if (resolvedSelectors) {
        return resolvedSelectors;
      }

      // Fallback to the control if we don't have a resolved selector
      if (!resolvedSelectors && selectorExperiment?.control) {
        return selectorExperiment.control;
      }

      // If we don't have a resolved selector and no control, we will return undefined,
      // which will result in a not available message
      return undefined;
    }
  }
  return undefined;
};

export const camelToTitle = (string: string) =>
  string.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (s) => s.toUpperCase());

export const configurationToInternalContent = (
  config: PriceAttribute[],
  extras: Record<string, string | number>,
): string => {
  const selection = [
    // Selector attributes
    ...config.map(({ name, value }) => [
      name.toLowerCase(),
      value.toLowerCase(),
    ]),
    // Price attributes
    ...Object.entries(extras).map(([name, value]) => [
      camelToTitle(name).toLowerCase(),
      String(value).toLowerCase(),
    ]),
  ].map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');

  return `?selection=${encodeURIComponent(selection)}`;
};
